// extracted by mini-css-extract-plugin
export default {"icon":"icon-I7Cneh","dropDown":"dropDown-jn_y9y","walletBtn":"walletBtn-oWdsAc"};